import {
  InteractionStepType,
  InteractionStepConfig,
  StepParamsForType,
} from '@scale/shared/types/chat';
import { IMultiTurnThreadHistory } from '../../../ThreadHistory.interface';
import ToolUseProcessSupervisionConfigurationComponent from 'react-scale/components/scalers/tasks/ThreadedInteraction/definitions/ProcessSupervision/ToolUseProcessSupervision/ToolUseProcessSupervisionConfigurationComponent';
import StepDescriptor from '../../stepDescriptor/StepDescriptor';
import { schema } from '../validation';
import ToolUseProcessSupervisionViewComponent from './ToolUseProcessSupervisionViewComponent';
import ToolUseProcessSupervisionPinnedViewComponent from './ToolUseProcessSupervisionPinnedViewComponent';

export class ToolUseProcessSupervisionDescriptor extends StepDescriptor<InteractionStepType.ToolUseProcessSupervision> {
  type = InteractionStepType.ToolUseProcessSupervision;
  title = InteractionStepConfig[InteractionStepType.ToolUseProcessSupervision].title;
  description = InteractionStepConfig[InteractionStepType.ToolUseProcessSupervision].description;

  validationSchema = schema;

  ViewComponent = ToolUseProcessSupervisionViewComponent;
  PinnedViewComponent = ToolUseProcessSupervisionPinnedViewComponent;
  ConfigurationComponent = ToolUseProcessSupervisionConfigurationComponent;

  getResponseTemplatePaths() {
    // Implementation to get response template paths
    return [];
  }

  generateEmptyResponse(
    _stepParams: StepParamsForType<InteractionStepType.ToolUseProcessSupervision>,
    history: IMultiTurnThreadHistory,
  ) {
    // const emptyResponse = createDefaultResponseForFields(this.params.params.fields);
    const emptyResponse = {};
    return {
      type: InteractionStepType.ExperimentalToolUse,
      context: {
        shouldContinue: false,
        response: emptyResponse,
      },
      output: history.getMostRecentResponse(),
    };
  }

  getConfigurationPreviewTags() {
    // Generate configuration preview tags
    return [];
  }
}
